import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { useTranslation } from "react-i18next";
import YoutubeIcon from "../../../shared/YoutubeIcon";

export const StatusBadge = ({ connected, loading }) => {
  const { t } = useTranslation();
  if (loading) return <div className="skeleton" style={{ width: 90, height: 22, borderRadius: 20 }} />;
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 5,
      fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20,
      background: connected ? "rgba(81,210,140,0.12)" : "rgba(107,114,128,0.1)",
      color: connected ? "#2da866" : "#9299a8",
    }}>
      <span style={{
        width: 6, height: 6, borderRadius: "50%",
        background: connected ? "#51d28c" : "#9299a8", display: "inline-block",
      }} />
      {connected ? t("Backend.Connections.Status.Connected") : t("Backend.Connections.Status.NotConnected")}
    </span>
  );
};

export const ComingSoonBadge = () => {
  const { t } = useTranslation();
  return (
    <span style={{
      display: "inline-flex", alignItems: "center",
      fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20,
      background: "rgba(107,114,128,0.1)", color: "#9299a8",
    }}>
      {t("Common.ComingSoon")}
    </span>
  );
};

export const IconBox = ({ icon, color, bgColor, letter }) => (
  <div style={{
    width: 52, height: 52, borderRadius: 14, flexShrink: 0,
    background: bgColor ?? `${color}18`,
    display: "flex", alignItems: "center", justifyContent: "center",
  }}>
    {icon === faYoutube
      ? <YoutubeIcon height={28} />
      : icon
      ? <FontAwesomeIcon icon={icon} style={{ fontSize: 28, color }} />
      : <span style={{ fontSize: 22, fontWeight: 700, color: "#9299a8" }}>{letter}</span>
    }
  </div>
);

export const ConnectCard = ({ name, icon, color, description, badge, action, extra = null, disabled = false }) => (
  <Card style={{ height: "100%", opacity: disabled ? 0.5 : 1 }}>
    <Card.Body style={{ padding: 24 }}>
      <div className="d-flex align-items-center gap-3 mb-3">
        <IconBox icon={icon} color={color} letter={name[0]} />
        <div>
          <div style={{ fontWeight: 700, fontSize: 16, color: "#111827", marginBottom: 4 }}>{name}</div>
          {badge}
        </div>
      </div>
      <p style={{ fontSize: 13, color: "#6b7280", marginBottom: extra ? 12 : 20, lineHeight: 1.6, minHeight: "calc(1.6em * 3)" }}>{description}</p>
      {extra}
      {action}
    </Card.Body>
  </Card>
);

export const SectionHeader = ({ label }) => (
  <div style={{
    fontSize: 11, fontWeight: 700, letterSpacing: "1.2px",
    textTransform: "uppercase", color: "#9299a8",
    marginBottom: 14, marginTop: 28, paddingBottom: 8,
    borderBottom: "1px solid #eaecf0",
  }}>
    {label}
  </div>
);

export const ConnectionGrid = ({ children }) => (
  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 16 }}>
    {children}
  </div>
);
